import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";
import { Checkbox } from "./Form";

export const CheckControl = styled(Checkbox)`
  position: relative;
  display: inline-block;
  width: 16px;
  min-width: 16px;
  height: 16px;
  min-height: 16px;
  flex-shrink: 0;
  appearance: none;
  border: ${vars.borderWidth.thin} solid ${vars.color.border.strong};
  border-radius: ${vars.radius.xxs};
  background: ${vars.color.background.surface};
  cursor: default;

  &:checked {
    border-color: ${vars.color.action.primaryPressed};
    background: ${vars.color.action.primaryPressed};
  }

  &:checked::after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 8px;
    border: solid ${vars.color.text.inverse};
    border-width: 0 2px 2px 0;
    content: "";
    transform: translate(-50%, -60%) rotate(45deg);
  }

  &:not(:checked):hover {
    border: 3px solid ${vars.color.border.strong};
  }
`;

export const CheckControlGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${vars.spacing.xxs};
`;

export type LegendShape = "circle" | "square" | "triangle";

export const LegendSymbol = styled.div<{
  $color: string;
  $dashArray?: string;
  $shape?: LegendShape;
}>`
  position: relative;
  display: flex;
  width: 28px;
  height: 12px;
  align-items: center;
  justify-content: center;

  &::before {
    width: 48px;
    border-top-width: 3px;
    border-top-style: ${({ $dashArray }) => ($dashArray ? "dashed" : "solid")};
    border-top-color: ${({ $color }) => $color};
    content: "";
  }
`;

export const LegendShapeIcon = styled.span<{
  $color: string;
  $shape?: LegendShape;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  transform: translate(-50%, -50%);

  ${({ $shape, $color }) =>
    $shape === "triangle"
      ? `
        width: 0;
        height: 0;
        background: var(--inzeloop-ds-color-background-transparent);
        border-left: 5px solid ${vars.color.border.transparent};
        border-right: 5px solid ${vars.color.border.transparent};
        border-bottom: 10px solid ${$color};
      `
      : `
        width: 10px;
        height: 10px;
        background: ${$color};
        border-radius: ${
          $shape === "circle" ? vars.radius.circle : vars.radius.none
        };
      `}
`;
